module.exports = __webpack_public_path__ + "assets/media/grafitti-texture-full.dc32913c.svg";